import { useEffect, useState } from "react";
import { api, formatApiError, downloadPdf } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Download, Receipt } from "lucide-react";
import { toast } from "sonner";

function formatMois(m) {
  if (!m) return "—";
  const [y, mo] = m.split("-");
  const noms = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"];
  return `${noms[parseInt(mo,10)-1] || mo} ${y}`;
}

export default function EmployeePayslips() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/payslips/my").then((r) => setItems(r.data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const dl = async (ps) => {
    try { await downloadPdf(`/payslips/${ps.id}/download`, ps.original_filename); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div>
      <PageHeader title="Mes bulletins de paie" subtitle="Consultez et téléchargez vos bulletins de paie mis à disposition par la RH." />
      <Card className="border-slate-200 overflow-hidden">
        {items.length === 0 ? (
          <div className="p-12 text-center">
            <Receipt className="h-10 w-10 text-slate-300 mx-auto" />
            <p className="mt-3 text-sm text-slate-500">Aucun bulletin disponible</p>
          </div>
        ) : (
          <>
          <div className="hidden md:block">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Mois</TableHead>
                <TableHead>Fichier</TableHead>
                <TableHead>Ajouté le</TableHead>
                <TableHead className="text-right">Action</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {items.map((p) => (
                <TableRow key={p.id} data-testid={`payslip-row-${p.id}`}>
                  <TableCell className="font-medium capitalize">{formatMois(p.mois)}</TableCell>
                  <TableCell className="text-sm text-slate-600">{p.original_filename}</TableCell>
                  <TableCell className="text-sm text-slate-500">{new Date(p.created_at).toLocaleDateString("fr-FR")}</TableCell>
                  <TableCell className="text-right">
                    <Button data-testid={`download-payslip-${p.id}`} size="sm" variant="outline" onClick={() => dl(p)}><Download className="h-3.5 w-3.5 mr-1" />Télécharger</Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          </div>
          <div className="md:hidden divide-y divide-slate-100">
            {items.map((p) => (
              <div key={p.id} className="p-4 flex items-center gap-3" data-testid={`payslip-card-${p.id}`}>
                <div className="h-10 w-10 shrink-0 rounded-lg bg-[#0066FF]/10 text-[#0066FF] flex items-center justify-center">
                  <Receipt className="h-5 w-5" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-medium text-slate-900 capitalize">{formatMois(p.mois)}</div>
                  <div className="text-[11px] text-slate-500 truncate">{p.original_filename}</div>
                </div>
                <Button data-testid={`download-payslip-m-${p.id}`} size="sm" variant="outline" onClick={() => dl(p)} className="shrink-0">
                  <Download className="h-3.5 w-3.5" />
                </Button>
              </div>
            ))}
          </div>
          </>
        )}
      </Card>
    </div>
  );
}
